import React, { useState, useContext, useRef, useEffect } from 'react'
import { handleScrollRef } from '../../../utils/safe'
import MainProdotto from '../../molecules/MainProdotto/MainProdotto'
import DettagliProdotto from '../../molecules/DettagliProdotto/DettagliProdotto'
import { QuantitaContext } from '../../../context/QuantitaContext'
import NewTableSchedaProdotto from '../../molecules/NewTableSchedaProdotto/NewTableSchedaProdotto'
import ModificaArticoli from '../../organisms/ModificaArticoli/ModificaArticoli'
import NewModal from '../../molecules/NewModal/NewModal'
import ModalBlocks from '../../molecules/ModalBlocks/ModalBlocks'
import { Button } from '../../atoms'
import LoadingSvg from '../../atoms/Loading/Loading'
import NonHaiTrovatoBox from '../../molecules/NonHaiTrovatoBox/NonHaiTrovatoBox'
import OrdineRiepilogoCard from '../../molecules/OrdineRiepilogoCard/OrdineRiepilogoCard'
import useTrans from '../../../hooks/useTrans'
import ProdottoContextProvider, { ProdottoContext } from '../../../context/ProdottoContext'
import {
  getIgnoraMinimiStampa,
  showDettagliPersonalizzaione,
  showDettagliProdotto,
  showPersonalizzazioneFormSchedaProdotto,
  showRiepilogo,
  showTabellaSchedaProdotto,
} from '../../../utils/servicegift'
import { useSelector } from 'react-redux'
import { Breadcrumbs, MetaSeo } from '../../index'
import { CartContext } from '../../../context/CartContext'
import Correlati from '../../organisms/Correlati/Correlati'
import { trackingProductDetail } from '../../../utils/gtm'
import { useRouter } from 'next/router'
import { api } from '../../../utils'
import * as Sentry from '@sentry/browser'
import { HandleWishlist } from '../../../utils/HelperNewProdottoCard/utils'
import { getError as getCartError } from '../../../utils/cart'
import {
  CARRELLO,
  RIGHECARRELLO,
  ORDINASUBITO,
  GETPRODOTTOVALUES,
  PROSSIMIARRIVI,
  WISHLISTELEMENTS,
  ADDTOMAIN,
  MOVETOLATER,
  COSTIPERSONALIZZAZIONE,
  PERSONALIZZAZIONI,
  PRODOTTI,
  RICHIEDIDISPONIBILITA,
  LEADTIMEPERSONALIZZAZIONI,
  LEADTIME,
} from '../../../utils/endpoint'
import { createToken } from '../../../pages/cart/checkout/[token]'
import { displayNotification } from '../../atoms/Notifica/Notifica'
import ConfigurazioneProdotto from '../../organisms/ConfigurazioneProdotto/ConfigurazioneProdotto'
import { useMemo } from 'react'
import QuantitaInsufficienteModal from '../../organisms/QuantitaInsufficienteModal/QuantitaInsufficienteModal'

const ProdottoTemplate = ({ page, data, slug, prodotto_articolo }) => {
  const {
    handleQuantita,
    onChangeInputQuantita,
    disabled,
    isValid,
    getError,
    getQuantita,
    updateQuantita,
    quantita,
    resetAllQuantita,
    setContextCart,
  } = useContext(QuantitaContext)
  const {
    showQuantitaInsufficiente,
    setShowQuantitaInsufficiente,
  } = useContext(ProdottoContext)

  const [carrello, setCarrello] = useState(null)
  const router = useRouter()
  const t = useTrans()
  const { utente } = useSelector((state) => state.utente)
  const { service_gift } = useSelector((state) => state.servicegift)
  const isAs400Down = useSelector((state) => state.servicegift.as400_down)
  const refTableSchedaProdotto = useRef(null)
  const refDettagliScheda = useRef(null)
  const refPersonalizzazione = useRef(null)
  const refInfoImballi = useRef()
  const [openAccordionsTabDettagli, setOpenAccordionsTabDettagli] = useState([
    'specifiche',
    'personalizzazione',
    'documentazione',
  ])
  const [selectedTabDettagli, setSelectedTabDettagli] = useState()
  const [showPersonalizzaForm, setShowPersonalizzaForm] = useState(false)
  const [showModificaArticoli, setShowModificaArticoli] = useState(false)
  const [editArticoloProps, setEditArticoloProps] = useState()
  const [prezziPersonalizzazioni, setPrezziPersonalizzazioni] = useState(null)
  const [leadTimePersonalizzazioni, setLeadTimePersonalizzazioni] = useState()
  const [personalizzazioni, setPersonalizzazioni] = useState(null)
  const [prodotto, setProdotto] = useState(data)
  const [Loading, setLoading] = useState()
  const [changingPreventivo, setChangingPreventivo] = useState(false)
  const [firstFetch, setFirstFetch] = useState(true)
  const { refreshCart, setCartMain } = useContext(CartContext)
  const [reload, setReload] = useState(false)
  const [isPreventivoFormValid, setPreventivoFormValid] = useState(false)
  const [needRecomputePreventivo, setNeedRecomputePreventivo] = useState(false) // per sapere se bisogna rieseguire l'aggiornaPreventivo
  const [isAggiornaPreventivoEnabled, setAggiornaPreventivoEnabled] = useState(false) // se la cta di aggiorna preventivo è attiva oppure no
  const [isAlreadyAggiornaPreventivoEnabled, setAlreadyAggiornaPreventivoEnabled] = useState(false) // per sapere se è già stata attivata la cta di aggiorna preventivo e quindi è già stato fatto un preventivo
  const [doRecomputePreventivo, setDoRecomputePreventivo] = useState(false) // per forzare l'esecuzione di aggiornaPreventivo
  const [selectedArticolo, setSelectedArticolo] = useState(
    slug ? prodotto_articolo : prodotto.articoli[0]
  )
  const [selectedTaglia, setSelectedTaglia] = useState(
    selectedArticolo
      ? selectedArticolo.attributi_lista.filter((item) => item.attributo == 8)[0]
      : ''
  )
  const [selectedColor, setSelectedColor] = useState(
    selectedArticolo
      ? selectedArticolo.attributi_lista.filter((item) => item.attributo == 7)[0]
      : data.colori[0]
  )
  const [prodottoWishlist, setProdottoWishlist] = useState(false)
  const [open, setOpen] = useState(false)
  const [modalContent, setModalContent] = useState(null)
  const [personalizzazionePrenotazione, setPersonalizzazionePrenotazione] = useState(null)
  const [tracked, setTracked] = useState(false)
  const [leadTimeSelected, setLeadTimeSelected] = useState(null)

  // PER SG NON INDICIZZO PRODOTTI
  if (service_gift) {
    page.seo.noindex = true
  }

  const scrollTo = (ref) => {
    handleScrollRef(ref)
  }

  const handleToggleAccordion = (accordionId) => {
    setOpenAccordionsTabDettagli((prevIds) => {
      if (prevIds.includes(accordionId)) {
        return prevIds.filter((id) => id !== accordionId)
      } else {
        return [...prevIds, accordionId]
      }
    })
  }

  const handleVisualizzaImballi = () => {
    setSelectedTabDettagli('dettagli')
    setOpenAccordionsTabDettagli((prevIds) => [
      ...prevIds.filter((id) => id !== 'info-imballi'),
      'info-imballi',
    ])
    setTimeout(() => {
      handleScrollRef(refInfoImballi)
    }, 200)
  }

  const OrdinaSubito = async () => {
    try {
      const response = await api.post(`${CARRELLO}${carrello?.id}/${ORDINASUBITO}`, {
        lang: router.locale,
      })
      const { id } = await response.data

      // controllo che i loghi siano stati caricati
      let loghiMancanti = false
      if (carrello.personalizzazioni_carrello) {
        carrello.personalizzazioni_carrello.forEach((personalizzazione) => {
          if (personalizzazione.posizioni) {
            if (
              !personalizzazione.posizioni[0].logo_file ||
              (!personalizzazione.stesso_logo && !personalizzazione.posizioni[1].logo_file)
            ) {
              loghiMancanti = true
            }
          }
        })
      }

      if (loghiMancanti) {
        if (utente) {
          router.push('/cart')
        } else {
          router.push('/myaccount/accedi?next=/cart')
        }
      } else {
        if (utente) {
          router.push(`/cart/checkout/${createToken(id)}`)
        } else {
          router.push(`/myaccount/accedi?next=/cart/checkout/${createToken(id)}`)
        }
      }
    } catch (err) {
      displayNotification(
        'error.ordinaSubito',
        getCartError(err, t('Qualcosa è andato storto')),
        'error'
      )
    }
  }

  useEffect(() => {
    if (showDettagliProdotto(utente, service_gift, isAs400Down)) {
      const params = {
        lang: router.locale,
      }
      api
        .get(`${PRODOTTI}${prodotto.codice}${PERSONALIZZAZIONI}`, { params })
        .then((data) => setPersonalizzazioni(data.data))
    }
  }, [utente, service_gift, isAs400Down])

  useEffect(() => {
    if (showDettagliPersonalizzaione(prodotto, service_gift)) {
      const params = {
        lang: router.locale,
      }
      api.get(`${PRODOTTI}${prodotto.codice}${COSTIPERSONALIZZAZIONE}`, { params }).then((data) => {
        setPrezziPersonalizzazioni(data.data)
      })
    }
  }, [prodotto, service_gift])

  useEffect(() => {
    showPersonalizzaForm === true && scrollTo(refPersonalizzazione)

    if (!showPersonalizzaForm) {
      setLeadTimeSelected(null)
    }
  }, [showPersonalizzaForm])

  const checkErrors = () => {
    let valid = true
    // ? E' stato aggiunto il check e il filtro per gli articolo che sono esclusi dalla personalizzazione
    const valore = quantita
      ?.filter((item) => item?.escludi_da_listino_di_stampa !== true)
      ?.reduce((previus, current) => previus + current.quantita, 0)

    if (
      !(
        valore >=
        (getIgnoraMinimiStampa(utente, service_gift)
          ? 0
          : prodotto?.quantita_minima_personalizzabile)
      )
    ) {
      valid = false
    }

    if (valid && isValid()) {
      return true
    } else {
      return false
    }
  }

  const AddToCartMain = React.useCallback(async () => {
    if (carrello && carrello.id) {
      setChangingPreventivo(true)
      api
        .post(`${CARRELLO}${carrello.id}/${ADDTOMAIN}`, {
          salvato_per_dopo: false,
          lang: router.locale,
        })
        .then((response) => {
          // ! Prima veniva messo setCarrello -> Ma questa Post riceve il Carrello Main non quello Preventivo
          setCarrello(null)
          refreshCart()
          displayNotification(
            'add_to_main',
            t('Hai aggiunto gli articoli nel Carrello'),
            'success',
            () => router.push('/cart/'),
            t('Vai al Carrello')
          )
          setChangingPreventivo(false)
          setShowPersonalizzaForm(false)
          resetAllQuantita() // una volta aggiunto al carrello resettiamo le quantita
          scrollTo(refTableSchedaProdotto)
        })
        .catch((err) => {
          setChangingPreventivo(false)
          displayNotification('error', getCartError(err, t('Qualcosa è andato storto')), 'error')
        })
    }
  })

  const SaveLater = async () => {
    if (!carrello) {
      return
    }
    setChangingPreventivo(true)
    api
      .post(`${CARRELLO}${carrello.id}/${MOVETOLATER}`, {
        salvato_per_dopo: true,
        lang: router.locale,
      })
      .then((response) => {
        displayNotification(
          'success.saveForLater',
          t('Hai salvato per dopo questi articoli'),
          'success',
          () => router.push('/cart/'),
          t('Vai al Carrello')
        )
        setCarrello(null)
        setChangingPreventivo(false)
        setShowPersonalizzaForm(false)
        resetAllQuantita() // una volta aggiunto al carrello resettiamo le quantita
        scrollTo(refTableSchedaProdotto)
      })
      .catch((err) => {
        setChangingPreventivo(false)
        displayNotification(
          'error.saveFprLater',
          getCartError(err, t('Qualcosa è andato storto')),
          'error'
        )
      })
  }

  const CreateModalContent = (articoli) => {
    return <ModalBlocks.ProssimiArrivi articoli={articoli} />
  }

  const deleteRigaCarrello = async (id) => {
    const rigaCarrello = carrello?.righe_carrello?.find((r) => r.id === id)
    await api
      .delete(`${RIGHECARRELLO}${id}/`)
      .then((response) =>
        api.get(CARRELLO + carrello.id + '/', { params: { lang: router.locale } })
      )
      .then((res) => {
        setCarrello(res.data)
        updateQuantita(rigaCarrello?.articolo?.codice, 0)
        displayNotification('success.delete.riga', t("Hai eliminato con successo l'articolo"))
      })
      .catch((err) =>
        displayNotification(
          'error.delete.riga',
          getCartError(err, t('Qualcosa è andato storto')),
          'error'
        )
      )
      .catch((err) =>
        displayNotification(
          'error.delete.riga',
          getCartError(err, t('Qualcosa è andato storto')),
          'error'
        )
      )
  }

  const CheckPrenotazione = (articoli) => {
    return articoli.filter((item) => item.prenotazione == true && item.quantita > 0)
  }

  const CarrelloPost = async (articoli, pers = null, isEdit, reload = false) => {
    let elements = articoli.filter((item) => item.quantita > 0)
    let carrelloId = carrello?.id ? `${carrello.id}/` : ''
    setChangingPreventivo(true)
    if (elements.length == 0) {
      return
    }

    const righe = articoli
      .filter((item) => item.quantita > 0)
      .map((item) => {
        return {
          salvato_per_dopo: false,
          personalizzazione_carrello_id: pers,
          prossimi_arrivi_ids: item.prenotazione
            ? item.prossimi_arrivi
              ? item.prossimi_arrivi.map((value) => value.id)
              : []
            : [],
          articolo_id: item.id,
          quantita: getQuantita(item?.codice),
        }
      })
    // ! Righe contiene la Quantità Giusta
    return carrello
      ? api
          .put(CARRELLO + carrelloId, {
            tipologia: 'PREVENTIVO',
            righe_carrello: righe,
            lang: router.locale,
            reset_carrello: true,
          })
          .then((response) => {
            setChangingPreventivo(false)
            setCarrello(response.data)
            displayNotification(
              response.data.id,
              isEdit
                ? t('Hai modificato la quantità con successo')
                : t('Hai aggiunto con Successo gli articoli')
            )
          })
          .catch((err) => {
            setChangingPreventivo(false)
            displayNotification(
              'error',
              getCartError(err, t('Qualcosa è andato storto')),
              'error'
            )
            return err
          })
      : api
          .post(CARRELLO, {
            tipologia: 'PREVENTIVO',
            lang: router.locale,
            reset_carrello: true,
            righe_carrello: articoli
              .filter((item) => item.quantita > 0)
              .map((item) => {
                return {
                  salvato_per_dopo: false,
                  personalizzazione_carrello_id: pers,
                  prossimi_arrivi_ids: item.prenotazione
                    ? item.prossimi_arrivi
                      ? item.prossimi_arrivi.map((value) => value.id)
                      : []
                    : [],
                  articolo_id: item.id,
                  quantita: item.quantita,
                }
              }),
          })
          .then((response) => {
            setChangingPreventivo(false)
            setCarrello(response.data)
            displayNotification(response.data.id, t('Hai aggiunto con Successo gli articoli'))
          })
          .catch((err) => {
            displayNotification('error', getCartError(err, t('Qualcosa è andato storto')))
            setChangingPreventivo(false)
            return err
          })
  }

  const resetData = async () => {
    await Setup()
  }

  const AddToCart = async (
    articoli = null,
    pers = null,
    checkPrenotazioneDisabled = false,
    handlePrenotazioneModal = true
  ) => {
    if (checkPrenotazioneDisabled) {
      await CarrelloPost(articoli ? articoli : quantita, pers)
      resetData()
      return true
    }
    const checked = CheckPrenotazione(articoli ? articoli : quantita)
    if (checked.length > 0) {
      if (handlePrenotazioneModal) {
        setPersonalizzazionePrenotazione(pers)
        setModalContent(CreateModalContent(checked))
        setOpen(true)
      }
      return false
    } else if (checked.length == 0) {
      const error = await CarrelloPost(articoli ? articoli : quantita, pers)
      if(error){
        return
      }
      resetData()
      return true
    }
  }

  const HandleColorClick = React.useCallback((colore) => {
    prodotto.articoli.filter(
      (item) => item.attributi_lista.filter((attributo) => attributo.id === colore.id).length > 0
    )[0] &&
      setSelectedArticolo(
        prodotto.articoli.filter(
          (item) =>
            item.attributi_lista.filter((attributo) => attributo.id === colore.id).length > 0
        )[0]
      )
    setSelectedColor(colore)
  })

  const ArrowClick = () => {
    HandleWishlist(prodottoWishlist, prodotto).then((response) => {
      setProdottoWishlist(response)
      displayNotification(
        response,
        t(`Hai ${response ? 'Aggiunto' : 'Rimosso'} dagli elementi salvati il prodotto`)
      )
    })
  }

  const GetWishlist = async (dataFetched) => {
    const params = {
      elements: dataFetched.id,
      lang: router.locale,
    }
    if (!utente) {
      return dataFetched
    }
    const response = await api
      .get(WISHLISTELEMENTS, { params })
      .then((response) => response.data[0]?.salvato && setProdottoWishlist(true))
  }

  const Setup = async () => {
    const match_article_slug = prodotto.articoli.filter((item) => item.slug == slug)[0]
    slug && setSelectedArticolo(match_article_slug ? match_article_slug : prodotto.articoli[0])
    slug &&
      setSelectedColor(
        selectedArticolo.attributi_lista.filter((element) => element.attributo == 7)[0]
      )
    slug &&
      setSelectedTaglia(selectedArticolo.attributi_lista.filter((item) => item.attributo == 8)[0])

    firstFetch && setLoading(true)
    const ids = data.articoli.map((item) => item.id)
    const params = {
      articoli_ids: ids,
      lang: router.locale,
    }
    let dataFetched = data
    try {
      await api.get(GETPRODOTTOVALUES, { params }).then(
        (response) =>
          response.data &&
          response.data.forEach((element) => {
            dataFetched.articoli
              .filter((item) => item.id == element.articolo__id)
              .forEach((articolo) => {
                articolo.prezzo = element.prezzo
                articolo.disponibilita = element.disponibilita
                articolo.disponibilita_reale_maggiore = element.disponibilita_reale_maggiore
                articolo.disponibilita_in_opzione = element.disponibilita_in_opzione
                articolo.data_in_opzione = element.data_in_opzione
                articolo.con_fasce = element.con_fasce
                articolo.fasce = element.fasce
                articolo.prezzo_listino = element.prezzo_listino
              })
          })
      )
      await api
        .get(PROSSIMIARRIVI, {
          params: { lang: router.locale, articolo__prodotto_id: data.id },
        })
        .then(
          (response) =>
            response.data &&
            response.data.forEach((element) => {
              dataFetched.articoli
                .filter((item) => item.id == element.articolo_id)
                .forEach((articolo) => {
                  if (articolo.prossimi_arrivi) {
                    articolo.prossimi_arrivi.filter((check) => check.id == element.id).length ==
                      0 && articolo.prossimi_arrivi.push(element)
                  } else {
                    articolo.prossimi_arrivi = []
                    articolo.prossimi_arrivi.push(element)
                  }
                })
            })
        )

      GetWishlist(dataFetched)
      setProdotto({ ...dataFetched })
    } catch (error) {
      console.log(error)
      Sentry.captureException(error)
      setLoading(false)
    }
  }

  useEffect(() => {
    resetAllQuantita()
    Setup()
      .then(() => {
        firstFetch && setLoading(false)
        firstFetch && setFirstFetch(false)
      })
      .catch((err) => {
        setLoading(false)
        console.log(err)
        Sentry.captureException(err)
      })
  }, [])

  useEffect(() => {
    if (reload && carrello && !Loading) {
      let carrelloId = carrello?.id ? `${carrello.id}/` : ''
      api
        .get(CARRELLO + carrelloId)
        .then((response) => {
          setCarrello(response.data)
        })
        .catch((err) => {})
      setReload(false)
    }
  }, [reload, carrello, Loading])

  useEffect(() => {
    GetWishlist(data)
  }, [prodotto])

  useEffect(() => {
    setContextCart(carrello)
  }, [carrello])

  useEffect(() => {
    if (prodotto && !Loading && Loading !== undefined && !tracked) {
      trackingProductDetail(prodotto, selectedArticolo, selectedTaglia, selectedColor)
      setTracked(true)
    }
  }, [Loading])

  useEffect(() => {
    if (selectedColor && selectedTaglia) {
      let articolo = prodotto.articoli
        .filter((item) => item.attributi_lista.find((element) => element.id === selectedColor.id))
        .find((item) => item.attributi_lista.find((element) => element.id === selectedTaglia.id))

      articolo = articolo
        ? articolo
        : prodotto.articoli.find((item) =>
            item.attributi_lista.find((element) => element.id === selectedColor.id)
          )

      setSelectedArticolo(articolo)
      setSelectedTaglia(articolo.attributi_lista.find((item) => item.attributo == 8))
    }
  }, [selectedColor, selectedTaglia])

  const OnClickRichiedi = async (id) => {
    await api
      .post(`${RICHIEDIDISPONIBILITA}`, { articolo: id, lang: router.locale })
      .then(
        displayNotification(
          'richiesta_disponibilita',
          t("Verrai notificato quando l'articolo tornerà disponibile"),
          'success'
        )
      )
  }

  const resetCarrello = () => {
    let carrelloId = carrello?.id ? `${carrello.id}/` : ''
    carrello
      ? api
          .put(CARRELLO + carrelloId, {
            tipologia: 'PREVENTIVO',
            righe_carrello: [],
            lang: router.locale,
            reset_carrello: true,
          })
          .then((response) => {
            setChangingPreventivo(false)
            setCarrello(response.data)
          })
          .catch((err) => {
            setChangingPreventivo(false)
            displayNotification('error', getCartError(err, t('Qualcosa è andato storto')), 'error')
          })
      : api
          .post(CARRELLO, {
            tipologia: 'PREVENTIVO',
            righe_carrello: [],
            lang: router.locale,
            reset_carrello: true,
          })
          .then((response) => {
            setChangingPreventivo(false)
            setCarrello(response.data)
          })
          .catch((err) => {
            displayNotification('error', getCartError(err, t('Qualcosa è andato storto')))
            setChangingPreventivo(false)
          })
  }

  const articoliQuantitaKey = useMemo(() => {
    return `${quantita?.map((x) => `${x.codice}-${x.quantita}`)}`
  }, [quantita])

  const quantitaTotale = useMemo(() => {
    return quantita
      ?.filter((item) => item?.escludi_da_listino_di_stampa !== true)
      ?.reduce((acc, curr) => acc + (curr.quantita || 0), 0)
  }, [quantita])

  useEffect(() => {
    if (!quantitaTotale && !showPersonalizzaForm) return

    const handler = setTimeout(() => {
      const params = {
        lang: router.locale,
        qty: quantitaTotale,
      }

      api
        .get(`${LEADTIME}${prodotto.codice}${LEADTIMEPERSONALIZZAZIONI}`, { params })
        .then((data) => setLeadTimePersonalizzazioni(data.data))
        .catch(console.error)
    }, 500)

    return () => {
      clearTimeout(handler)
    }
  }, [quantitaTotale, showPersonalizzaForm])

  useEffect(() => {
    // quando cambia la quantità di un articolo devo ricalcolare il preventivo
    if (quantita?.length > 0 && carrello?.righe_carrello?.length > 0) {
      setNeedRecomputePreventivo(true)
    }
  }, [articoliQuantitaKey])

  useEffect(() => {
    if (!showPersonalizzaForm) {
      setAlreadyAggiornaPreventivoEnabled(false)
      setAggiornaPreventivoEnabled(false)
    } else {
      // all'apertura del form se è già stato fatto un preventivo lo resetto
      carrello?.righe_carrello?.length > 0 && resetCarrello()
    }
  }, [showPersonalizzaForm])

  const isQuantitaValid = () => {
      let valid = true
      // ? E' stato aggiunto il check e il filtro per gli articolo che sono esclusi dalla personalizzazione
      const valore = quantita
        ?.filter((item) => item?.escludi_da_listino_di_stampa !== true)
        ?.reduce((previus, current) => previus + current.quantita, 0)
  
      if (
        !(
          valore >=
          (getIgnoraMinimiStampa(utente, service_gift)
            ? 1
            : prodotto?.quantita_minima_personalizzabile)
        )
      ) {
        valid = false
      }
  
      if (valid) {
        return true
      } else {
        return false
      }
    }

  useEffect(() => {
      if (showPersonalizzaForm) {
        setShowQuantitaInsufficiente(!isQuantitaValid())
      }
    }, [quantita, showPersonalizzaForm])

  return (
    <>
      <div className="page">
        <MetaSeo seo={page.seo} />
        <div className="w-container">
          <Breadcrumbs breadcrumbs={page.breadcrumbs} />
        </div>
        <div className="w-container">
          <MainProdotto
            setSelectedTaglia={setSelectedTaglia}
            utente={utente}
            mail_campioni={prodotto.mailto_campioni}
            prodotto={prodotto}
            selectedArticolo={selectedArticolo}
            selectedTaglia={selectedTaglia}
            selectedColor={selectedColor}
            HandleColorClick={HandleColorClick}
            wishlist={prodottoWishlist}
            ArrowClick={ArrowClick}
            service_gift={service_gift}
            scrollToDettagli={() => scrollTo(refDettagliScheda)}
            scrollToTableSchedaProdotto={() => scrollTo(refTableSchedaProdotto)}
            personalizzazioni={personalizzazioni}
            prezziPersonalizzazioni={prezziPersonalizzazioni}
            leadTimeSelected={leadTimeSelected}
          />
          <div className="prodotto-template__cols">
            <div className="prodotto-template__main" ref={refTableSchedaProdotto}>
              {showTabellaSchedaProdotto(utente, service_gift, isAs400Down) && (
                <>
                  <div className="prodotto-template__block">
                    <NewTableSchedaProdotto
                      showSelectorTaglia={true}
                      showSelectorColore={true}
                      utente={utente}
                      quantita={quantita}
                      setSelectedTaglia={setSelectedTaglia}
                      setSelectedColor={selectedColor}
                      showPersonalizzaForm={showPersonalizzaForm}
                      setShowPersonalizzaForm={setShowPersonalizzaForm}
                      selectedArticolo={selectedArticolo}
                      prodotto={prodotto}
                      handleQuantita={handleQuantita}
                      onChangeInputQuantita={onChangeInputQuantita}
                      disabled={disabled}
                      isValid={isValid}
                      articoliQuantita={quantita}
                      AddToCart={AddToCart}
                      service_gift={service_gift}
                      OnClickRichiedi={OnClickRichiedi}
                      personalizzazioni={personalizzazioni}
                      leadTimePersonalizzazioni={leadTimePersonalizzazioni}
                      handleVisualizzaImballi={handleVisualizzaImballi}
                    />
                  </div>
                </>
              )}
              {showPersonalizzazioneFormSchedaProdotto(utente, service_gift, isAs400Down) &&
                showPersonalizzaForm && (
                  <div className="prodotto-template__block" ref={refPersonalizzazione}>
                    <ConfigurazioneProdotto
                      setShowPersonalizzaForm={setShowPersonalizzaForm}
                      // articoliQuantita={quantita?.filter(
                      //   (item) => item?.escludi_da_listino_di_stampa !== true
                      // )}
                      setReload={setReload}
                      isLoading={changingPreventivo}
                      setLoading={setChangingPreventivo}
                      AddToCart={AddToCart}
                      AddToCartMain={AddToCartMain}
                      OrdinaSubito={OrdinaSubito}
                      SaveLater={SaveLater}
                      ModificaArticoli={() => setShowModificaArticoli(true)}
                      prodotto={prodotto}
                      selectedArticolo={selectedArticolo}
                      personalizzazioni={personalizzazioni}
                      prezziPersonalizzazioni={prezziPersonalizzazioni}
                      leadTimePersonalizzazioni={leadTimePersonalizzazioni}
                      quantita={quantita?.filter(
                        (item) => item?.escludi_da_listino_di_stampa !== true
                      )}
                      ordine={carrello}
                      resetCarrello={resetCarrello}
                      needRecomputePreventivo={needRecomputePreventivo}
                      setNeedRecomputePreventivo={setNeedRecomputePreventivo}
                      isAggiornaPreventivoEnabled={isAggiornaPreventivoEnabled}
                      setAggiornaPreventivoEnabled={setAggiornaPreventivoEnabled}
                      isAlreadyAggiornaPreventivoEnabled={isAlreadyAggiornaPreventivoEnabled}
                      setAlreadyAggiornaPreventivoEnabled={setAlreadyAggiornaPreventivoEnabled}
                      doRecomputePreventivo={doRecomputePreventivo}
                      setDoRecomputePreventivo={setDoRecomputePreventivo}
                      isFormValid={isPreventivoFormValid}
                      setFormValid={setPreventivoFormValid}
                      variant="prodotto"
                      leadTimeSelected={leadTimeSelected}
                      setLeadTimeSelected={setLeadTimeSelected}
                    />
                  </div>
                )}
            </div>

            <div className="prodotto-template__sidebar">
              {/* // ! Inserire un altro Modifica Articoli da modificare da dentro OrdineRiepilogoCard */}
              {showRiepilogo(utente, service_gift, isAs400Down) && (
                <OrdineRiepilogoCard
                  isLoading={changingPreventivo}
                  ordine={carrello}
                  AddToCartMain={AddToCartMain}
                  isProdotto={true}
                  prodotto={prodotto}
                  SaveLater={SaveLater}
                  ModificaArticoli={() => setShowModificaArticoli(true)}
                  setEditArticoloProps={setEditArticoloProps}
                  OrdinaSubito={OrdinaSubito}
                  variant="prodotto"
                  disabledActions={
                    showPersonalizzaForm || // se faccio duplica personalizzazione non si apre il form ma devo poter aggiungere al carrello
                    !(carrello?.righe_carrello?.length > 0)
                  }
                  aggiornaPreventivo={
                    showPersonalizzaForm &&
                    !isAggiornaPreventivoEnabled &&
                    isAlreadyAggiornaPreventivoEnabled // la cta compare solo se è la seconda volta (isAlreadyAggiornaPreventivoEnabled)
                      ? () => setDoRecomputePreventivo(true)
                      : undefined
                  }
                  isPreventivoFormValid={isPreventivoFormValid}
                />
              )}

              {editArticoloProps?.initialSelectedArticolo && (
                <ModificaArticoli
                  AddToCart={AddToCart}
                  setCarrello={setCarrello}
                  isVisible={editArticoloProps?.show}
                  setVisible={(value) => {
                    const new_value = value
                    setEditArticoloProps((prev_state) => ({ ...prev_state, show: new_value }))
                  }}
                  preventivo={carrello}
                  prodotto={prodotto}
                  initialStep={editArticoloProps?.initialStep}
                  initialId={editArticoloProps?.initialId}
                  initialSelectedArticolo={editArticoloProps?.initialSelectedArticolo}
                  initialQuantitaProps={editArticoloProps?.initialQuantita}
                  service_gift={service_gift}
                  key={`modifica_articoli_${editArticoloProps?.initialId}`}
                />
              )}

              {/* // ? Viene utilizzato per il Modifica Articoli con la scelta di Opzione  */}
              <ModificaArticoli
                AddToCart={AddToCart}
                setCarrello={setCarrello}
                isVisible={showModificaArticoli}
                setVisible={setShowModificaArticoli}
                preventivo={carrello}
                prodotto={prodotto}
                service_gift={service_gift}
                key={`modifica_articoli`}
              />
            </div>
          </div>
          {/* Mostro i dettagli prodotto se l'utente è loggato oppure se è servicegift vetrina */}
          {showDettagliProdotto(utente, service_gift, isAs400Down) && (
            <div className="prodotto-template__cols">
              <div className="prodotto-template__main">
                <div ref={refDettagliScheda} className="prodotto-template__block">
                  <DettagliProdotto
                    showSelectorTaglia={selectedTaglia ? true : false}
                    showSelectorColore={selectedColor ? true : false}
                    prodotto={prodotto}
                    selectedArticolo={selectedArticolo}
                    selectedColore={selectedColor}
                    selectedTaglia={selectedTaglia}
                    personalizzazioni={personalizzazioni}
                    prezziPersonalizzazioni={prezziPersonalizzazioni}
                    refInfoImballi={refInfoImballi}
                    selectedTab={selectedTabDettagli}
                    setSelectedTab={setSelectedTabDettagli}
                    openAccordions={openAccordionsTabDettagli}
                    handleToggleAccordion={handleToggleAccordion}
                    setOpenAccordions={setOpenAccordionsTabDettagli}
                  ></DettagliProdotto>
                </div>
              </div>
              <div className="prodotto-template__sidebar"></div>
            </div>
          )}
        </div>

        {/* Wide - non è dentro al container */}
        <NonHaiTrovatoBox />

        <DeleteFromRiepilogoCard
          onDelete={async () => await deleteRigaCarrello(editArticoloProps?.initialId)}
          visible={editArticoloProps?.show_delete}
          setVisible={(value) =>
            setEditArticoloProps((prev_state) => ({ ...prev_state, show_delete: value }))
          }
        />
        <Correlati />
        <NewModal
          visible={open}
          alert={true}
          title={'La quantità inserita non è disponibile, desideri prenotarla?'}
          text={
            <>
              <p>
                {t(
                  'La quantita inserita non è disponibile subito, ma è possibile prenotarla su più arrivi.'
                )}
                <br />
                {t(
                  "L'ordine verrà evaso dal prossimo arrivo della merce che soddisfa le quantità richieste."
                )}
              </p>
              <p>{t('Se vuoi ricevere subito gli articoli, inserisci una quantità disponibile')}</p>
            </>
          }
          className={'prenota-modal'}
          onClose={() => setOpen(false)}
          actions={[
            <Button
              label={t('Modifica quantità')}
              variant="secondary"
              size="medium"
              onClick={() => setOpen(false)}
            />,
            <Button
              label={t('Conferma prenotazione')}
              variant="primary"
              size="medium"
              onClick={() => {
                AddToCart(null, personalizzazionePrenotazione, true)
                setOpen(false)
              }}
            />,
          ]}
        >
          {modalContent}
        </NewModal>
        <QuantitaInsufficienteModal
          isVisible={showQuantitaInsufficiente}
          setVisible={(v) => {
            setShowQuantitaInsufficiente(v)

            if (showPersonalizzaForm && !v) {
              setShowPersonalizzaForm(false)
            }
          }}
          quantita_minima_personalizzabile={prodotto?.quantita_minima_personalizzabile}
        />
      </div>
    </>
  )
}

export default ProdottoTemplate

export const DeleteFromRiepilogoCard = ({ visible, setVisible, onDelete }) => {
  const [Loading, setLoading] = useState(false)
  const _handleDelete = async () => {
    setLoading(true)
    await onDelete()
    setLoading(false)
    setVisible(false)
  }
  return (
    <NewModal
      visible={visible}
      onClose={() => setVisible(false)}
      title="Sei sicuro di voler Eliminare questo articolo?"
    >
      {Loading ? (
        <LoadingSvg />
      ) : (
        <ModalBlocks.Actions>
          <Button label="Annulla" variant="secondary" onClick={() => setVisible(false)} />
          <Button
            label="Conferma e elimina"
            variant="primary"
            onClick={() => {
              onDelete && _handleDelete()
            }}
          />
        </ModalBlocks.Actions>
      )}
    </NewModal>
  )
}
